export default "__VITE_ASSET__YqBHFSRDozNW5VpX$B1Gaw__"